import * as React from 'react';
import { Icon, TooltipHost, TooltipDelay, DirectionalHint, ICalloutProps } from 'office-ui-fabric-react';
import { Description } from './Description';

type InfoHintProps = {
    description: string | JSX.Element | JSX.Element[];
    calloutProps?: ICalloutProps;
    iconClassName?: string;
    id?: string;
}

export const InfoHint = (props: InfoHintProps) => (
    <TooltipHost
        calloutProps={{ ...props.calloutProps, directionalHint: DirectionalHint.topLeftEdge }}
        tooltipProps={{ onRenderContent: () => <Description value={props.description} /> }}
        hostClassName="align-center"
        className='field-hint'
        delay={TooltipDelay.zero}
        id={props.id}
    >
        <Icon
            onClick={(e) => e.stopPropagation()}
            iconName="Info"
            className={props.iconClassName ?? 'callout-icon'}
        />
    </TooltipHost>
);

export default InfoHint;
